import { takeLatest, call, put, all, select } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import Api from '../../utils/Api';
import UserProfileTypes from './userDetails.actionTypes';
import UtilsTypes from '../utilities/utils.types';
import { clearLocalStorage, getCookie } from '../../utils/commonFunctions';
import Loader from '../../utils/Loader';
import { getReturnPath } from './userDetails.selectors';
import { getUserDetails } from '../userAuthentication/userAuth.selectors';
import { tagEvent } from '../../utils/tagManager';

function* setError(msg) {
	if (msg === 'Token is Invalid' || msg === 'Token is missing') {
		clearLocalStorage();
		yield put(push('/'));
	} else {
		yield put({ type: UtilsTypes.SET_ERROR_MSG, payload: msg });
	}

	Loader.hide();
}

function* getUserProfile(data) {
	try {
		const returnPath = yield select(getReturnPath);
		const res = yield call(Api, {
			url: 'v3/user_profile',
			method: 'GET',
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.code === 200) {
				Loader.hide();
				const {
					newUser,
					isRetail,
					loginType,
					onboarding,
					isInternational,
				} = yield select(getUserDetails);
				const { org_id, org_name } = res.data;
				yield call(tagEvent, {
					event: 'web_signin',
					is_international: isInternational,
					user_id: res.data.user_id,
					user_name: res.data.user_name,
					user_mail: res.data.email,
					full_name: res.data.full_name,
					user_phone: res.data.phone,
					login_type: loginType,
					signup: newUser,
					is_retail: isRetail,
					...(org_id && { org_id }),
					...(org_name && { org_name }),
					admitad_uid: !!getCookie('admitad_uid')
						? getCookie('admitad_uid')
						: 'step',
				});

				if (localStorage.getItem('postBuySignIn') === 'true') {
					yield call(tagEvent, {
						event: 'post_buy_sign_in',
						user_id: res.data.user_id,
						product_name: localStorage.getItem('gtm_prod_name'),
						final_product_value: localStorage.getItem('gtm_prod_final'),
						email: res.data.email,
						phone: res.data.phone,
						product_id: parseInt(localStorage.getItem('currentProductId'), 10),
					});
				}

				let { email, full_name, phone } = res.data;
				let userDetailsObj = {
					user_mail: email,
					full_name: full_name,
					user_phone: phone,
				};
				localStorage.setItem('userDetails', JSON.stringify(userDetailsObj));
				yield put({ type: UtilsTypes.SET_ERROR_PANEL, payload: {} });
				yield put({
					type: UserProfileTypes.SET_USER_DETAILS,
					payload: { ...res.data, fullName: res.data.full_name },
				});
				yield put({
					type: 'UPDATE_FULL_NAME',
					payload: res.data.full_name,
				});

				if (!onboarding) {
					yield put(push('/onboard/step1'));
				} else if (
					!['/', '/verifyuser', '/logout', '/signup', '/parent/verifyotp'].includes(
						returnPath.toLowerCase(),
					)
				) {
					yield put(push(returnPath));
				} else {
					yield put(push('/mydashboard'));
				}
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (error) {
		console.log(error.message);
	}
}

function* updateUserProfile(data) {
	try {
		const res = yield call(Api, {
			url: 'v3/user_profile',
			method: 'GET',
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.code === 200) {
				Loader.hide();
				yield put({ type: UserProfileTypes.SET_USER_DETAILS, payload: res.data });
				yield put(push('/mydashboard'));
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (error) {
		console.log(error.message);
	}
}

function* getUserProfileStart() {
	yield takeLatest(UserProfileTypes.GET_USER_PROFILE.PENDING, getUserProfile);
}

function* UpdateUserProfileStart() {
	yield takeLatest(
		UserProfileTypes.UPDATE_USER_PROFILE.PENDING,
		updateUserProfile,
	);
}

export function* userProfileSagas() {
	yield all([call(UpdateUserProfileStart), call(getUserProfileStart)]);
}
